export const environment = {
  appVersion: 'local V ' + require('../../package.json').version,
  // domainApi: 'localhost:3000',
  // apiUrl: 'http://localhost:3000',
  domainApi: 'mkt-api.siamese-marketing.com',
  apiUrl: 'https://mkt-api.siamese-marketing.com',
  production: false,
  authService: '/auth',
  roleService: '/roles',
  staffService: '/staff',
  marketingService: '/marketing',
  leadsService: '/lead',
  bookingService: '/booking-report',
  privilegeService: '/api/privilege',
};
